import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  notNilOrEmpty,
  mapIndexed
} from '_utils'

import SuggestionItem from '_views/suggestionItem'

const sugMap = (label, tReg, pathFn) => R.compose(
  mapIndexed((text, idx) => (<SuggestionItem key={label + idx} label={label} text={text} tReg={tReg} />)),
  R.uniq,
  R.filter(notNilOrEmpty),
  R.flatten, // in case we get an array of arrays like with FS ORDERS
  R.defaultTo([]),
  R.map(pathFn)
)

const SuggestionItems = ({list, pathFn, label, tReg}) => (
  <React.Fragment>
    { sugMap(label, tReg, pathFn)(list) }
  </React.Fragment>
)

SuggestionItems.propTypes = {
  list: PropTypes.array.isRequired,
  pathFn: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  tReg: PropTypes.object.isRequired
}

export default SuggestionItems



// WEBPACK FOOTER //
// ./webAdmin/views/suggestionItems.js